<div [formGroup]="form">
    <div class="row">
        <div class="col-sm-2 bolded">
            {{ "CampDetails.DayVariantName" | translate }}
        </div>
        <div class="col-sm-8">{{ form.controls.name.value }}</div>
        <div class="col-sm-2">
            @if (state.canEdit | async) {
                <button
                    class="btn btn-action btn-primary pull-right"
                    [disabled]="isOtherItemEdited"
                    bcClick
                    (clicked)="edit()"
                >
                    {{ "General.Edit" | translate }}
                </button>
            }
            @if (state.canEdit | async) {
                <button
                    class="btn btn-danger btn-action pull-right mr-1"
                    [disabled]="isOtherItemEdited"
                    bcClick
                    (clicked)="remove()"
                >
                    {{ "General.Remove" | translate }}
                </button>
            }
        </div>
    </div>
    <div class="row">
        <div class="col-sm-2 bolded">{{ "CampDetails.Order" | translate }}</div>
        <div class="col-sm-10">{{ form.controls.order.value }}</div>
    </div>
    <div class="row">
        <div class="col-sm-2 bolded">
            {{ "CampDetails.VisibleInConnect" | translate }}
        </div>
        <div class="col-sm-10">
            {{ form.controls.isVisibleToMembers.value | yesno }}
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-sm-2 bolded">
            {{ "CampDetails.DayVarianDates" | translate }}
        </div>

        <div class="col-sm-10">
            <app-dates-selector
                name="daysDates"
                [allowedDates]="form.controls.allDays.value"
                formControlName="daysDates"
                [readonly]="true"
            ></app-dates-selector>
        </div>
    </div>
    <hr />
</div>
